var _g, _path, _rect, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkFrom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.9043,
    y: 11.1431,
    width: 12.381,
    height: 13.619,
    rx: 2,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14.8574H19.1905",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21.0479L16.0952 21.0479",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17.9526H19.1905",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33053 0.910174C9.62446 0.970078 9.81473 1.25538 9.75558 1.54741L9.59927 2.31913C11.3158 0.845621 13.7116 0.235097 16.0638 0.940527C18.5942 1.69941 20.394 3.8027 20.8553 6.28771C20.9098 6.58106 20.715 6.86188 20.4202 6.91494C20.1253 6.968 19.8422 6.77324 19.7878 6.47987C19.3973 4.37679 17.8765 2.61057 15.7538 1.974C13.8192 1.39379 11.7731 1.87086 10.3027 3.13858L11.2023 2.83482C11.4858 2.73909 11.7946 2.89033 11.8919 3.17262C11.9893 3.45494 11.8383 3.7614 11.5548 3.85716L8.82687 4.77828C8.42719 4.91284 8.03657 4.56278 8.11847 4.15866L8.69131 1.33051C8.75044 1.03845 9.03663 0.850278 9.33053 0.910174Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.47656,
    y: 7.42871,
    width: 12.381,
    height: 13.619,
    rx: 2,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57227 11.1431H11.7627",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57227 17.3335L8.6675 17.3335",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57227 14.2383H11.7627",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkFrom);
export default __webpack_public_path__ + "static/media/link_from.65fc0ad8.svg";
export { ForwardRef as ReactComponent };